export function scrollToRequiredElement(element, ref) {
	return element.$refs[ref].scrollIntoView({ behavior: 'smooth' });
}